import React from 'react';
import styled, { css } from 'styled-components';
import Check from 'utils/images/check.svg';

const CheckboxStyles = styled.span`
  ${props => (props.tall ? '41px' : '30px')};
  height: ${props => (props.tall ? '41px' : '30px')};

  border-color: ${props => (props.selected ? 'black' : '#DDDDDD')};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: '28px' !important;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 4px 0px 0.2px 20px;
  font-family: 'Basier Circle';
  line-height: 16px;
  font-size: 13px;
  color: black;
  max-width: max-content;
  cursor: pointer;

  ${props =>
    props.noMargin
      ? css`
          margin: 0px !important;
        `
      : ''}

  &:hover {
    border-color: black;
    cursor: pointer;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.4;

      :hover {
        border-color: #dddddd;
        cursor: default;
      }
    `}
`;

const CheckboxInput = styled.span`
  height: 14px;
  width: 14px;
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 2px;
  margin-right: 10px !important;
  background-color: white;

  ${props =>
    props.selected
      ? css`
          border-color: black;
          background-color: black;
        `
      : css`
          border: 1px solid #000000;
          box-sizing: border-box;
        `}
`;

const CheckIcon = styled.img`
  margin-left: 2px;
  margin-bottom: 3px;
`;
const Label = styled.span`
  ${props =>
    props.selected
      ? css`
          color: #000000;
        `
      : css`
          color: #7a7a7b;
        `}
`;

export function EditorCheckbox(props) {
  const label = props.label || props.value;

  return (
    <CheckboxStyles
      style={props.style}
      className={props.className}
      selected={props.isChecked}
      disabled={props.disabled}
      onClick={() =>
        props.disabled ? null : props.onSelect(props.value, !props.isChecked)
      }
      tall={props.tall}
      noMargin={props.noMargin}
    >
      <CheckboxInput selected={props.isChecked}>
        <CheckIcon src={Check} />
      </CheckboxInput>
      <Label selected={props.isChecked}>{label}</Label>
    </CheckboxStyles>
  );
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorCheckbox/EditorCheckbox.jsx